<!--
todo : implementer les boutons "ajouter un droit" et "trash"
      utiliser l'idCompany qui vient de la page CompanyPage.value


-->

<template>
  <page-outline :title="$t('administration.company_dtls')">
    <template slot="pageContent">
      <b-row v-if="this.$engine.company.redirection === '0'" class="pb-3 mx-0">
        <back-button class="btnFilter_2" :returnUrl="returnUrl"></back-button>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <div v-else>
        <div class="mt-0">
          <b-row class="text-xl-start mb-1">
            <b-col xl="9" lg="12" md="12" cols="12">

              <!-- Super-menu : Global / Core / B2B -->
              <b-button-group class="mt-3 mt-sm-0">
                <b-button class="px-4" :variant="tabName === 0 ? 'primary btn-selected' : ''"
                  @click="tabName = 0;">{{ $t('mandate.remittance_generation.global') }}</b-button>
                <b-button class="px-4" :variant="tabName === 1 ? 'primary btn-selected' : ''"
                  @click="tabName = 1;">{{ $t('mandate.remittance_generation.habilitation') }}</b-button>
                <b-button class="px-4" :variant="tabName === 2 ? 'primary btn-selected' : ''"
                  @click="tabName = 2;">{{ $t('mandate.remittance_generation.parameter') }}</b-button>
              </b-button-group>
              <div class="mb-2"></div>
            </b-col>
          </b-row>
        </div>
        <b-tabs v-model="tabName" class="mt-3" nav-class="d-none">
          <b-tab>
            <template v-if="CompaniesList.length > 0" >
              <div class="title-label-blue w-200px mb-n1px pt-3">{{$t('administration.company_info')}}</div>
              <table class="table">
                <tbody>
                  <tr>
                    <th class="text-center w-50">
                      {{ $t("mandate.parent_node") }}
                    </th>
                    <td class="text-center w-50">
                      {{
                        CompaniesList[0].account.name_parent
                          ? CompaniesList[0].account.name_parent
                          : "-"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th class="text-center w-50">{{ $t('administration.company_id') }}</th>
                    <td class="text-center w-50">{{ CompaniesList[0].account.identifier ? CompaniesList[0].account.identifier : '-' }}</td>
                  </tr>
                  <tr>
                    <th class="text-center w-50">{{ $t('administration.company_name') }}</th>
                    <td class="text-center w-50">{{ CompaniesList[0].account.name ? CompaniesList[0].account.name : '-' }}</td>
                  </tr>
                  <tr>
                    <th class="text-center w-50">{{ $t('administration.company_email') }}</th>
                    <td class="text-center w-50">{{ CompaniesList[0].account.email_reference ? CompaniesList[0].account.email_reference : '-' }}</td>
                  </tr>
                  <tr>
                    <th class="text-center w-50">
                      {{ $t('administration.active') }}
                    </th>
                    <td class="text-center w-50">
                      <i v-if="CompaniesList[0].active == 0" class="fa-duotone fa-xmark btn-icon text-danger p-0"></i>
                      <i v-if="CompaniesList[0].active == 2" class="fa-duotone fa-check btn btn-icon text-success p-0"></i>
                      <i v-if="CompaniesList[0].active == 1" class="fa-duotone fa-warning btn btn-icon text-warning p-0"></i>
                    </td>
                  </tr>
                  <tr>
                    <th class="text-center w-50">{{ $t('administration.address') }}</th>
                    <td class="text-center w-50">{{ CompaniesList[0].account.address ? CompaniesList[0].account.address : '-' }}</td>
                  </tr>
                  <tr>
                    <th class="text-center w-50">{{ $t('administration.city') }}</th>
                    <td class="text-center w-50">{{ CompaniesList[0].account.city ? CompaniesList[0].account.city : '-' }}</td>
                  </tr>
                  <tr>
                    <th class="text-center w-50">{{ $t('administration.zip_code') }}</th>
                    <td class="text-center w-50">{{ CompaniesList[0].account.zip_code ? CompaniesList[0].account.zip_code : '-' }}</td>
                  </tr>
                  <tr>
                    <th class="text-center w-50">{{ $t('administration.country') }}</th>
                    <td class="text-center w-50">{{ CompaniesList[0].account.country ? CompaniesList[0].account.country : '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </template>
            <b-row class="min-w-100 align-items-center">
              <b-col class="d-flex justify-content-end">
                <template v-if="canCompanyDelete ||canCompanyEdit">
                  <b-button
                    class="back-button btnFilter_2 mr-2"
                    @click="activateCompanyEdit(CompaniesList[0].idCompany)">
                    <i class="fa-light fa-pencil"></i>  {{ $t('administration.company_edit') }}
                  </b-button>
                  <b-button
                    class="back-button btnFilter_2"
                    @click="activateCompanyDelete(CompaniesList[0].idCompany)"
                  >
                    <span><i class="fa-light fa-trash"></i>{{ $t('administration.company_delete') }}</span>
                  </b-button>
                </template>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <template>
              <div class="title-label-blue w-200px mb-n1px pt-3">{{$t('mandate.technical_access.title')}}</div>
              <table class="table">
                <tbody>
                  <tr>
                    <th class="text-center w-50">{{ $t('mandate.technical_access.technical_user_id') }}</th>
                    <td class="text-center w-50">{{ technicalUserLogin || '-' }}</td>
                  </tr>
                </tbody>
              </table>
              <b-form-checkbox :disabled="!isEditable" v-model="technicalUser">
                {{ $t('mandate.technical_access.technical_user_mode') }}
              </b-form-checkbox>
              <b-container fluid>
                <certificate-form-global
                v-show="technicalUser"
                ref="keystoreFormGlobal"
                :technical-user="technicalUser"
                :mode="formType"
                :id="id"
                :id-certificate="idCertificate"
                :id-private-key="idPrivateKey"
                :id-company="idCompany"
                :id-user-api="idUserApi"
                :id-rights-profile-api="idRightsProfileApi"
                :name-company="nameCompany"
                :readonly="!isEditable">
              </certificate-form-global>
              </b-container>
            </template>
            <b-row class="d-flex justify-content-end">
              <div>
                <b-button class="back-button btnFilter_2 mr-2" @click="switchMode('view')" v-if="this.isEditable && this.formType !== 'add'">
                  <span>{{ $t("common.cncl") }}</span>
                </b-button>
              </div>
              <div>
                <b-button class="back-button btnFilter_2 mr-2" @click="switchMode('edit')" v-if="!this.isEditable">
                  <span>{{ $t("administration.edit") }}</span>
                </b-button>
                <b-button class="back-button btnFilter_2 mr-2"
                  v-if="this.isEditable && this.formType !== 'add'"
                  @click="saveKeystore()">
                  <span>{{ $t("common.sve") }}</span>
                </b-button>
              </div>
            </b-row>

            <br>
            <hr class="mx-auto" />
            <br>


            <!-- COMPANY USERS -->
            <div class="title-label-blue w-200px pt-3">{{$t('administration.company_users')}}</div>
            <table class="table">
              <thead>
                <th class="text-center w-200px">
                  Login
                </th>
                <th class="text-center w-200px">
                  Name
                </th>
              </thead>
              <tbody>
                <template v-if="filteredUsers.length > 0">
                  <tr @click="seeDetailsUser(result)" v-for="result in filteredUsers">
                    <!-- <td class="text-center" :title="result.libelle">{{ result.libelle }}</td> -->
                    <td class="cursor text-ellipsis">{{ result.login }}</td>
                    <td v-if="!result.name">-</td>
                    <td v-else class="cursor text-ellipsis">{{ result.name }}</td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="6" class="noResult">
                    {{ $t('common.no_result') }}
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <b-table hover fixed responsive
            ref="userList"
            class="mt-3"
            :fields="userListFields"
            :items="CompaniesList[0].users"
            :selectable="CompaniesList[0].users.length > 0"
            :sort-by.sync="sortBy"
            :empty-text="$t('errors.No_results_found')"
            @row-selected="seeDetailsUser">
              <template #cell(login)="data">
                <div class="cursor text-ellipsis">{{ data.value }}</div>
              </template>
              <template #cell(name)="data">
                <div v-if="!data.value">-</div>
                <div v-else class="cursor text-ellipsis">{{ data.value }}</div>
              </template>
            </b-table> -->
            <b-row v-if="canAddUser" class="no-gutter d-flex justify-content-end">
              <b-button class="back-button btnFilter_2"
                @click="addUser">
                <i class="fa-light fa-plus"></i>
                <span>{{$t('administration.user_add')}}</span>
              </b-button>
            </b-row>

            <br>
            <hr class="mx-auto" />
            <br>

            <!-- COMPANY PROFILES -->
            <div class="title-label-blue w-200px pt-3">{{$t('administration.company_prfls')}}</div>
            <table class="table">
              <thead>
                <th class="text-center w-200px">
                  {{ $t('administration.label') }}
                </th>
              </thead>
              <tbody>
                <template v-if="filteredProfiles.length">
                  <tr @click="seeDetailsProfile(result)" v-for="result in filteredProfiles">
                    <td class="text-center" :title="result.libelle">{{ result.libelle }}</td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="6" class="noResult">
                    {{ $t('common.no_result') }}
                  </td>
                </tr>
              </tbody>
            </table>
            <b-row v-if="canAddRole" class="no-gutter d-flex justify-content-end">
              <b-button class="back-button btnFilter_2"
                @click="addRole">
                <i class="fa-light fa-plus"></i>
                <span>{{$t('administration.profile_add')}}</span>
              </b-button>
            </b-row>

            <br>
            <hr class="mx-auto" />
            <br>

            <!-- COMPANY RIGHTS -->
            <div class="title-label-blue w-200px pt-3">{{$t('administration.company_rights')}}</div>
            <table class="table text-center">
              <thead>
                <th>
                  {{$t('administration.right_list')}}
                </th>
              </thead>
              <tbody>
                <template v-if="CompaniesList.length > 0">
                  <tr v-for="result in CompaniesList[0].rights">
                    <td :title="$t('rights.db_rights.' + result) === ('rights.db_rights.' + result) ? result : $t('rights.db_rights.' + result)">
                      {{ $t('rights.db_rights.' + result) === ('rights.db_rights.' + result) ? result : $t('rights.db_rights.' + result) }}
                    </td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="6" class="noResult">
                    {{ $t('common.no_result') }}
                  </td>
                </tr>
              </tbody>
            </table>
          </b-tab>
          <b-tab>
            <form-accordion open :title="$t('mandate.remittance_generation.sdd_remittance_generation')">
              <div class="sdd-generation-settings">
                <!-- Déclenchement manuel -->
                <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="generationManual"
                      type="radio"
                      class="custom-control-input"
                      name="generationRadio"
                      value="manual"
                      v-model="generationMode"
                      :disabled="!doesEdit"
                    />
                    <label class="custom-control-label" for="generationManual">
                      {{ $t('mandate.remittance_generation.manual_trigger') }}
                    </label>
                  </div>
                </div>

                <!-- Fin du batch -->
                <!-- <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="generationBatch"
                      type="radio"
                      class="custom-control-input"
                      name="generationRadio"
                      value="batch"
                      v-model="generationMode"
                      :disabled="!doesEdit"
                    />
                    <label class="custom-control-label" for="generationBatch">
                      À la fin du batch: Intégration des fichiers de transaction
                    </label>
                  </div>
                </div> -->

                <!-- Dans l'intervalle -->
                <div class="generation-row interval-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="generationInterval"
                      type="radio"
                      class="custom-control-input"
                      name="generationRadio"
                      value="auto"
                      v-model="generationMode"
                      :disabled="!doesEdit"
                    />
                    <label class="custom-control-label" for="generationInterval">
                      {{ $t('mandate.remittance_generation.within_interval') }}
                    </label>
                  </div>

                  <div class="interval-selects">
                    <select
                      class="form-control form-control-sm"
                      v-model="generationFrequency"
                      :disabled="!doesEdit || generationMode !== 'auto'"
                    >
                      <option value="daily">{{ $t('mandate.remittance_generation.daily') }}</option>
                      <option value="weekly">{{ $t('mandate.remittance_generation.weekly') }}</option>
                    </select>

                    <select
                      class="form-control form-control-sm space"
                      v-model="generationTime"
                      :disabled="!doesEdit || generationMode !== 'auto'"
                    >
                      <option
                        v-for="hour in 24"
                        :key="hour - 1"
                        :value="`${String(hour - 1).padStart(2, '0')}-${String(
                          hour % 24,
                        ).padStart(2, '0')}`"
                      >
                        {{ hour - 1 }}h - {{ hour % 24 }}h
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </form-accordion>
            <form-accordion open :title="$t('mandate.remittance_generation.sdd_remittance_file_generation')">
              <div class="sdd-generation-settings">
                <!-- Déclenchement manuel -->
                <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sddgenerationManual"
                      type="radio"
                      class="custom-control-input"
                      name="sddgenerationRadio"
                      value="manual"
                      v-model="generationModeSDD"
                      :disabled="!doesEdit"
                    />
                    <label class="custom-control-label" for="sddgenerationManual">
                      {{ $t('mandate.remittance_generation.manual_trigger') }}
                    </label>
                  </div>
                </div>

                <!-- Fin du batch -->
                <!-- <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="generationBatch"
                      type="radio"
                      class="custom-control-input"
                      name="generationRadio"
                      value="batch"
                      v-model="generationMode"
                      :disabled="!doesEdit"
                    />
                    <label class="custom-control-label" for="generationBatch">
                      À la fin du batch: Génération des remises SDD
                    </label>
                  </div>
                </div> -->

                <!-- Dans l'intervalle -->
                <div class="generation-row interval-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sddgenerationInterval"
                      type="radio"
                      class="custom-control-input"
                      name="sddgenerationRadio"
                      value="auto"
                      v-model="generationModeSDD"
                      :disabled="!doesEdit"
                    />
                    <label class="custom-control-label" for="sddgenerationInterval">
                      {{ $t('mandate.remittance_generation.within_interval') }}
                    </label>
                  </div>

                  <div class="interval-selects">
                    <select
                      class="form-control form-control-sm"
                      v-model="generationFrequencySDD"
                      :disabled="!doesEdit || generationModeSDD !== 'auto'"
                    >
                      <option value="daily">{{ $t('mandate.remittance_generation.daily') }}</option>
                      <option value="weekly">{{ $t('mandate.remittance_generation.weekly') }}</option>
                    </select>

                    <select
                      class="form-control form-control-sm space"
                      v-model="generationTimeSDD"
                      :disabled="!doesEdit || generationModeSDD !== 'auto'"
                    >
                      <option
                        v-for="hour in 24"
                        :key="`sdd-${hour - 1}`"
                :value="`${String(hour - 1).padStart(2, '0')}-${String(hour % 24).padStart(2, '0')}`"
                      >
                        {{ hour - 1 }}h - {{ hour % 24 }}h
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </form-accordion>
            <!-- Génération des remises SCT -->
            <form-accordion open :title="$t('mandate.remittance_generation.sct_remittance_generation')">
              <div class="sct-generation-settings">
                <!-- Déclenchement manuel -->
                <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctGenerationManual"
                      type="radio"
                      class="custom-control-input"
                      name="sctGenerationRadio"
                      value="manual"
                      v-model="sctGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label class="custom-control-label" for="sctGenerationManual">
                      {{ $t('mandate.remittance_generation.manual_trigger') }}
                    </label>
                  </div>
                </div>

                <!-- Après le batch -->
                <!-- <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctGenerationBatch"
                      type="radio"
                      class="custom-control-input"
                      name="sctGenerationRadio"
                      value="batch"
                      v-model="sctGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label class="custom-control-label" for="sctGenerationBatch">
                      Après la fin du batch : Génération des remises SCT
                    </label>
                  </div>
                </div> -->

                <!-- Après la création du fichier SCT via -->
                <!-- <div class="generation-row sct-file-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctGenerationFile"
                      type="radio"
                      class="custom-control-input"
                      name="sctGenerationRadio"
                      value="file"
                      v-model="sctGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label class="custom-control-label" for="sctGenerationFile">
                      Après la création du fichier SCT via :
                    </label>
                  </div>

                  <div class="sct-file-options">
                    <div class="custom-control custom-checkbox">
                      <input
                        id="sctFileIntegration"
                        type="checkbox"
                        class="custom-control-input"
                        v-model="sctFileIntegration"
                        :disabled="!doesEdit || sctGenerationMode !== 'file'"
                      />

                      <label class="custom-control-label" for="sctFileIntegration">
                        Intégration d'un fichier
                      </label>
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        id="sctFileWeb"
                        type="checkbox"
                        class="custom-control-input"
                        v-model="sctFileWeb"
                        :disabled="!doesEdit || sctGenerationMode !== 'file'"
                      />

                      <label class="custom-control-label" for="sctFileWeb">
                        Web
                      </label>
                    </div>

                    <div class="custom-control custom-checkbox">
                      <input
                        id="sctFileWebService"
                        type="checkbox"
                        class="custom-control-input"
                        v-model="sctFileWebService"
                        :disabled="!doesEdit || sctGenerationMode !== 'file'"
                      />

                      <label class="custom-control-label" for="sctFileWebService">
                        Web Service
                      </label>
                    </div>
                  </div>
                </div> -->

                <!-- Dans l'intervalle -->
                <div class="generation-row interval-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctGenerationInterval"
                      type="radio"
                      class="custom-control-input"
                      name="sctGenerationRadio"
                      value="auto"
                      v-model="sctGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label class="custom-control-label" for="sctGenerationInterval">
                      {{ $t('mandate.remittance_generation.within_interval') }}
                    </label>
                  </div>

                  <div class="interval-selects">
                    <select
                      class="form-control form-control-sm"
                      v-model="sctGenerationFrequency"
                      :disabled="!doesEdit || sctGenerationMode !== 'auto'"
                    >
                      <option value="daily">{{ $t('mandate.remittance_generation.daily') }}</option>

                      <option value="weekly">{{ $t('mandate.remittance_generation.weekly') }}</option>
                    </select>

                    <select
                      class="form-control form-control-sm space"
                      v-model="sctGenerationTime"
                      :disabled="!doesEdit || sctGenerationMode !== 'auto'"
                    >
                      <option
                        v-for="hour in 24"
                        :key="`sct-generation-${hour - 1}`"
                        :value="`${String(hour - 1).padStart(2, '0')}-${String(
                          hour % 24,
                        ).padStart(2, '0')}`"
                      >
                        {{ hour - 1 }}h - {{ hour % 24 }}h
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </form-accordion>

            <!-- Génération du fichier de remises SCT -->
            <form-accordion open :title="$t('mandate.remittance_generation.sct_remittance_file_generation')">
              <div class="sct-file-generation-settings">
                <!-- Déclenchement manuel -->
                <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctFileGenerationManual"
                      type="radio"
                      class="custom-control-input"
                      name="sctFileGenerationRadio"
                      value="manual"
                      v-model="sctFileGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label
                      class="custom-control-label"
                      for="sctFileGenerationManual"
                    >
                      {{ $t('mandate.remittance_generation.manual_trigger') }}
                    </label>
                  </div>
                </div>

                <!-- À la fin du batch -->
                <!-- <div class="generation-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctFileGenerationBatch"
                      type="radio"
                      class="custom-control-input"
                      name="sctFileGenerationRadio"
                      value="batch"
                      v-model="sctFileGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label
                      class="custom-control-label"
                      for="sctFileGenerationBatch"
                    >
                      À la fin du batch : Génération des remises SCT
                    </label>
                  </div>
                </div> -->

                <!-- Dans l'intervalle -->
                <div class="generation-row interval-row">
                  <div class="custom-control custom-radio">
                    <input
                      id="sctFileGenerationInterval"
                      type="radio"
                      class="custom-control-input"
                      name="sctFileGenerationRadio"
                      value="auto"
                      v-model="sctFileGenerationMode"
                      :disabled="!doesEdit"
                    />

                    <label
                      class="custom-control-label"
                      for="sctFileGenerationInterval"
                    >
                      {{ $t('mandate.remittance_generation.within_interval') }}
                    </label>
                  </div>

                  <div class="interval-selects">
                    <select
                      class="form-control form-control-sm"
                      v-model="sctFileGenerationFrequency"
                      :disabled="!doesEdit || sctFileGenerationMode !== 'auto'"
                    >
                      <option value="daily">{{ $t('mandate.remittance_generation.daily') }}</option>

                      <option value="weekly">{{ $t('mandate.remittance_generation.weekly') }}</option>
                    </select>

                    <select
                      class="form-control form-control-sm space"
                      v-model="sctFileGenerationTime"
                      :disabled="!doesEdit || sctFileGenerationMode !== 'auto'"
                    >
                      <option
                        v-for="hour in 24"
                        :key="`sct-file-generation-${hour - 1}`"
                        :value="`${String(hour - 1).padStart(2, '0')}-${String(
                          hour % 24,
                        ).padStart(2, '0')}`"
                      >
                        {{ hour - 1 }}h - {{ hour % 24 }}h
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </form-accordion>
            <form-accordion
  open
  :title="$t('mandate.remittance_generation.expiring_extraction')"
>
  <div class="expiring-mandates-settings">
    <div class="generation-row interval-row">
      <div class="custom-control custom-radio">
      <label for="expiringMandatesType">
        {{ $t('mandate.remittance_generation.type') }}
      </label>
      </div>
 <div class="interval-selects-type">
      <select
        id="expiringMandatesType"
        class="form-control form-control-sm"
        v-model="expiringMandatesType"
        :disabled="!doesEdit"
      >
        <option value="manual">
          {{ $t('mandate.remittance_generation.none') }}
        </option>
        <option value="ftp">
          {{ $t('mandate.remittance_generation.ftp') }}
        </option>
      </select>
      </div>
    </div>
  </div>
</form-accordion>
            <div v-if="true">
              <b-row class="d-flex justify-content-end">
                <div v-if="doesEdit">
                  <b-button class="back-button btnFilter_2 mr-2" @click="resetSettings">
                    <span>{{ $t("common.cncl") }}</span>
                  </b-button>
                </div>
                <div>
                  <b-button class="back-button btnFilter_2 mr-2" v-if="!doesEdit" @click="editSettings">
                    <span>{{ $t("administration.edit") }}</span>
                  </b-button>
                  <b-button class="back-button btnFilter_2 mr-2"
                    v-if="doesEdit"
                    @click="updateSettings"
                  >
                    <span>{{ $t("common.update") }}</span>
                  </b-button>
                </div>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
        <!-- <br>
        <hr class="mx-auto" />
        <br> -->


      </div>
    </template>
  </page-outline>
</template>

<script>
// import moment from 'moment'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage, reloadPage2} from './../../helpers/routing'
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import FormAccordion from "@/components/common/FormAccordion.vue";
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import CertificateFormGlobal from "@/pages/administration/CertificateFormGlobal.vue"

export default {
  name: 'CompanyDetails',
  components: {
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner,
    "form-accordion": FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput,
    'certificate-form-global': CertificateFormGlobal
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    canAddUser () {
      return this.$engine.rights.rightIs('usercompany_ajouter', true)
    },
    canAddRole () {
      return this.$engine.rights.rightIs('profilcompany_ajouter', true)
    },
    canCompanyDelete () {
      return this.$engine.rights.rightIs('company_supprimer', true)
    },
    canCompanyEdit () {
      return this.$engine.rights.rightIs('company_editer', true)
    },
    filteredProfiles () {
      if (this.CompaniesList.length) {
        return this.CompaniesList[0].profiles.filter(elem => {
          return !elem.libelle.includes('Norm_')
        })
      }
      return []
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      return 'Details de l\'entreprise'
    },
    userListFields () {
      return [
        { key: 'login', isActive: false, label: this.$i18n.t('administration.login'), class: 'w-50', thClass: 'text-left pl-4', tdClass: 'pl-4'},
        { key: 'name', label: this.$i18n.t('administration.user_name'), class: 'w-50', thClass: 'text-left pl-4', tdClass: 'pl-4'}
      ]
    },
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    filteredUsers () {
      if (!this.CompaniesList.length || !this.CompaniesList[0].users) {
        return []
      }

      return this.CompaniesList[0].users.filter(user => Number(user.type) === 2)
    },
    technicalUserLogin () {
      const users = this.CompaniesList[0]?.users || []
      const technicalUser = users.find(user => Number(user.type) === 3)

      return technicalUser ? technicalUser.login : ''
    }
  },
  props: {
    idCompany: {
      type: String
    },
    mode: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: '-1'
    },
    nameCompany: {
      type: String
    }
  },
  data () {
    return {
      activateSpinner: false,
      CompaniesList: [],
      profiles: [],
      redirection: this.$engine.company.redirection,
      returnUrl: '/company/',
      sortBy: 'login',
      tabName: 0,
      superTab: 'global',
      generationMode: "",
      generationFrequency: "",
      generationTime: "",
      generationModeSDD: "",
      generationFrequencySDD: "",
      generationTimeSDD: "",
      // Génération des remises SCT
      sctGenerationMode: "",
      sctGenerationFrequency: "",
      sctGenerationTime: "",

      sctFileIntegration: false,
      sctFileWeb: false,
      sctFileWebService: false,

      // Génération du fichier de remises SCT
      sctFileGenerationMode: "",
      sctFileGenerationFrequency: "",
      sctFileGenerationTime: "",
      doesEdit: false,
      expiringMandatesType: 'none',
      technicalUser: false,
      technicalUserOrig: false,
      idUser: '',
      formType: '',
      idCertificate: '',
      idPrivateKey: '',
      idUserApi: '',
      idRightsProfileApi: ''
    }
  },
  created () {
    this.returnUrl = this.returnUrl + this.redirection
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'entreprise',
      returnUrl: ''
    })

    this.$engine.settings.set({msgDirection: this.direction})
    this.atStart(this.idCompany) // modif a check
    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
    this.formType = this.mode
    this.idUser = this.$engine.user.get().id

  },
  methods: {
    addUser () {
      let that = this
      this.$engine.company.profiles = that.CompaniesList[0].profiles
      loadPage(that, {url: '/addusercompany/' + this.idCompany})
    },
    addRole () {
      let that = this
      this.$engine.company.profiles = that.CompaniesList[0].profiles
      this.$engine.company.rightsL = this.CompaniesList[0].rights
      loadPage(that, {url: '/addprofilcompany/' + this.idCompany})
    },
    atStart (val = 1) {
      let that = this
      that.pageCounter = 0
      that.activateSpinner = true
      // this.$engine.company.idCompany = val
      // that.$engine.company.idCompany = val
      that.CompaniesList = []
      let filterConditions = that.$engine.company.getConditionObject()
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      that.$engine.company.getCompany(
        val,
        10,
        1,
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.company) {
          resp.data.company.idCompany = val
          resp.data.company.identifier = resp.data.company.account.identifier
          resp.data.company.name = resp.data.company.account.name
          resp.data.company.email_reference = resp.data.company.account.email_reference
          resp.data.company.active = resp.data.company.account.active
          that.idCertificate = resp.data.company.account.id_certificate || ''
          that.idPrivateKey = resp.data.company.account.id_privatekey || ''
          resp.data.company.rights = resp.data.company.rights
          resp.data.company.profiles.forEach(item => {
            item.id_rights_profile = item.id_rights_profile
            item.libelle = item.libelle
          })
          resp.data.company.users.forEach(item => {
            item.id_user_account = item.id_user_account
            item.login = item.login
          })
          const users = resp.data.company.users || []
          that.technicalUser = users.some(user => Number(user.type) === 3)
          requests = resp.data.company

          const technicalUserId = users.find(user => Number(user.type) === 3)
          that.idUserApi = technicalUserId ? technicalUserId.id_user_account : ''

          const profiles = resp.data.company.profiles || []
          const IdRightsProfileApi =  profiles.find(profile => profile.libelle === "Api")
          that.idRightsProfileApi = IdRightsProfileApi ? IdRightsProfileApi.id_rights_profile : ''
          that.nameCompany = resp.data.company.account.name

          const settings = resp.data.company.settings || []

          const getSetting = (parameterName) =>
            settings.find((setting) => setting.parameterName === parameterName)?.parameterValue

          that.generationModeSDD = getSetting("SDDRemitttanceFileGenerationMode")
          that.generationFrequencySDD = getSetting("SDDRemitttanceFileGenerationFrequency")
          that.generationTimeSDD = getSetting("SDDRemitttanceFileGenerationInterval")

          that.sctFileGenerationMode = getSetting("SCTRemitttanceFileGenerationMode")
          that.sctFileGenerationFrequency = getSetting("SCTRemitttanceFileGenerationFrequency")
          that.sctFileGenerationTime = getSetting("SCTRemitttanceFileGenerationInterval")

          that.generationMode = getSetting("SDDRemitttanceGenerationMode")
          that.generationFrequency = getSetting("SDDRemitttanceGenerationFrequency")
          that.generationTime = getSetting("SDDRemitttanceGenerationInterval")

          that.sctGenerationMode = getSetting("SCTRemitttanceGenerationMode")
          that.sctGenerationFrequency = getSetting("SCTRemitttanceGenerationFrequency")
          that.sctGenerationTime = getSetting("SCTRemitttanceGenerationInterval")

          that.expiringMandatesType = getSetting("MandateExpiredExtract")

          that.CompaniesList.push(requests)
          that.CompaniesList[0].profiles.sort((a, b) => {
            return a.libelle.toUpperCase() > b.libelle.toUpperCase() ? 1 : -1
          })
          that.$f7.pullToRefreshDone()
          that.$bus.$emit('refresh-cache-paging-template', this.paginationObject)
        }
        // that.CompaniesList.push(requests)
        that.activateSpinner = false
      }).catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    activateCompanyEdit (ressource) {
      let that = this
      this.$engine.company.profiles = that.CompaniesList[0].profiles
      loadPage(this, {url: '/editcompany/' + ressource})
    },
    activateCompanyDelete (ressource) {
      let that = this
      if (ressource === this.$engine.user.get().id) {
        that.$f7.modal({
          title: this.$i18n.t('Impossible de supprimer votre propre entreprise'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      } else {
        this.$f7.modal({
          title: 'Voulez vous vraiment supprimer cette entreprise',
          buttons: [
            {
              text: this.$t('creation_forms.vldt'),
              onClick: function () {
                that.$engine.company.deleteCompany(ressource)
                .then(resp => {
                  that.$f7.alert('', that.$t('Entreprise supprimé'))
                  loadPage(that, {url: '/company/' + that.redirection})
                })
              }
            },
            {
              text: this.$t('common.cncl'),
              onClick: function () {
                return
              }
            }
          ]
        })
      }
    },
    editSettings() {
      this.doesEdit = true;
    },
    refreshProfileList () {
    },
    resetSettings() {
      this.settings = Object.assign({}, this.originalSettings);
      this.doesEdit = false;
      this.resetInput = !this.resetInput;
    },
    seeDetailsProfile (profile) {
      console.log('profile', profile)
      this.$engine.company.rightsL = this.CompaniesList[0].rights
      loadPage(this, {url: 'editprofilcompany/' + profile.id_rights_profile + '/' + this.idCompany})
    },
    seeDetailsUser (user) {
        this.$engine.company.profiles = this.CompaniesList[0].profiles
        loadPage(this, {url: '/detailusercompany/' + user.id_user_account + '/' + this.idCompany})
    },
    updateInbox (requests, noAttach) {
    },
    switchMode (mode) {
      this.formType = mode
    },
    saveKeystore () {
      if (!this.technicalUser && this.technicalUserOrig) {
        let that = this
        that.activateSpinner = true
        this.$engine.security.certificates.delete({id: this.idCertificate})
        .then(() => {
          this.$engine.security.private_keys.delete({id: that.idPrivateKey})
          .then(() => {
            that.activateSpinner = false
            this.$engine.company.editCompany(
              this.idCompany,
              this.CompaniesList[0].account.identifier,
              this.CompaniesList[0].account.name,
              this.CompaniesList[0].account.email_reference ? this.CompaniesList[0].account.email_reference : '##NULL##',
              this.CompaniesList[0].account.active,
              this.CompaniesList[0].account.address,
              this.CompaniesList[0].account.city,
              this.CompaniesList[0].account.zip_code,
              this.CompaniesList[0].account.country,
              this.CompaniesList[0].rights,
              this.CompaniesList[0].account.cdtr_scheme_id
            ).then(resp => {
              that.$f7.hidePreloader()
              that.$f7.modal({
                title: that.$i18n.t('administration.edit_company'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: '/company/' + that.redirection})
            })
            .catch(e => {
              errorMessageAlert(e, that)
              that.$f7.modal({
                title: that.$i18n.t('administration.edit_error'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
            })
          })
          .catch(errPKI => {
            that.activateSpinner = false
            errorMessageAlert(errPKI, that, that.$i18n)
          })
        })
        .catch(errCert => {
          that.activateSpinner = false
          errorMessageAlert(errCert, that, that.$i18n)
        })
      } else {
        const form = this.$refs.keystoreFormGlobal
        if (form) {
          form.saveKeystore()
        } else {
          console.warn('Le formulaire keystore est introuvable')
        }
      }
    },
    updateSettings() {
      const settingsGroups = [
        {
          label: this.$t('mandate.remittance_generation.sdd_remittance_file_generation'),
          mode: this.generationModeSDD,
          frequency: this.generationFrequencySDD,
          time: this.generationTimeSDD,
          names: {
            mode: 'SDDRemitttanceFileGenerationMode',
            frequency: 'SDDRemitttanceFileGenerationFrequency',
            time: 'SDDRemitttanceFileGenerationInterval'
          }
        },
        {
          label: this.$t('mandate.remittance_generation.sct_remittance_file_generation'),
          mode: this.sctFileGenerationMode,
          frequency: this.sctFileGenerationFrequency,
          time: this.sctFileGenerationTime,
          names: {
            mode: 'SCTRemitttanceFileGenerationMode',
            frequency: 'SCTRemitttanceFileGenerationFrequency',
            time: 'SCTRemitttanceFileGenerationInterval'
          }
        },
        {
          label: this.$t('mandate.remittance_generation.sdd_remittance_generation'),
          mode: this.generationMode,
          frequency: this.generationFrequency,
          time: this.generationTime,
          names: {
            mode: 'SDDRemitttanceGenerationMode',
            frequency: 'SDDRemitttanceGenerationFrequency',
            time: 'SDDRemitttanceGenerationInterval'
          }
        },
        {
          label: this.$t('mandate.remittance_generation.sct_remittance_generation'),
          mode: this.sctGenerationMode,
          frequency: this.sctGenerationFrequency,
          time: this.sctGenerationTime,
          names: {
            mode: 'SCTRemitttanceGenerationMode',
            frequency: 'SCTRemitttanceGenerationFrequency',
            time: 'SCTRemitttanceGenerationInterval'
          }
        }
      ];

      const isEmpty = value =>
        value === undefined || value === null || value === '';

      for (const group of settingsGroups) {
        if (isEmpty(group.mode)) {
          this.$f7.alert(this.$t('mandate.remittance_generation.select_generation_mode', { label: group.label }), 'Erreur');
          return;
        }

        if (group.mode === 'auto') {
          if (isEmpty(group.frequency)) {
            this.$f7.alert(this.$t('mandate.remittance_generation.select_generation_frequency', { label: group.label }), 'Erreur');
            return;
          }

          if (isEmpty(group.time)) {
            this.$f7.alert(this.$t('mandate.remittance_generation.select_generation_time', { label: group.label }), 'Erreur');
            return;
          }
        }
      }
      if (isEmpty(this.expiringMandatesType)) {
        this.$f7.alert(this.$t('mandate.remittance_generation.select_expiring_mandates_type'), 'Erreur');
        return;
      }
      // const settings = settingsGroups.flatMap(group => {
      //   const parameters = [
      //     {
      //       parameterName: group.names.mode,
      //       parameterValue: group.mode
      //     }
      //   ];
      //
      //   // La fréquence et l'heure ne sont envoyées qu'en mode automatique.
      //   if (group.mode === 'auto') {
      //     parameters.push(
      //       {
      //         parameterName: group.names.frequency,
      //         parameterValue: group.frequency
      //       },
      //       {
      //         parameterName: group.names.time,
      //         parameterValue: group.time
      //       }
      //     );
      //   }
      //
      //   return parameters;
      // });
      // settings.push({
      //   parameterName: 'MandateExpiredExtract',
      //   parameterValue: this.expiringMandatesType
      // })
      const parameter = {};

      settingsGroups.forEach(group => {
        parameter[group.names.mode] = group.mode;

        if (group.mode === 'auto') {
          parameter[group.names.frequency] = group.frequency;
          parameter[group.names.time] = group.time;
        }
      });

      parameter.MandateExpiredExtract = this.expiringMandatesType;
      this.$engine.company.editSettings({
        idCompany: this.idCompany,
        parameter
      })
      .then(resp => {
        const page = this;

        page.$f7.modal({
          title: page.$i18n.t('mandate.remittance_generation.settings_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: () => {
                loadPage(page, { url: '/company/-1' });
              }
            }
          ]
        });
      })
      .catch(err => {
        errorMessageAlert(err, this);
      })

    }
  }
}
</script>
<style scoped>
.btn.btn-secondary {
  background: var(--actionButtonColorViolet);
  border: 2px solid var(--borderButtonColorBlue);
  color: var(--actionTextColorBlue);
}

.sdd-select {
  display: block;
  width: 90px;
}

.justify-content-around label {
  display: block;
  font-size: 0.82rem;
  color: #6c757d;
  margin-bottom: 2px;
}

.justify-content-around label.sdd-label-main,
.d-flex label.sdd-label-main {
  font-size: 1rem !important;
  color: #212529 !important;
  margin-bottom: 1rem !important;
}
.sdd-select-header label {
  display: block;
  text-align: center;
  font-size: 1rem !important;
  color: #212529 !important;
  margin-bottom: 2px;
}
.justify-content-around label:not(.sdd-label-main) {
  font-size: 1rem !important;
  color: #212529 !important;
}
.sdd-generation-settings {
  padding: 5px 0 10px 300px;
}
.sct-generation-settings {
  padding: 5px 0 10px 300px;
}
.sct-file-generation-settings {
  padding: 5px 0 10px 300px;
}
.expiring-mandates-settings {
  padding: 5px 0 10px 280px;
}
.generation-row {
  margin-bottom: 2px;
}

.custom-control {
  min-height: 18px;
  padding-left: 25px;
}

.custom-control-label::before,
.custom-control-label::after {
  width: 12px;
  height: 12px;
  top: 3px;
}

.interval-row {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 25px;
}

.interval-selects {
  display: flex;
  gap: 5px;
  margin-left: 100px;
  margin-top: -2px;
}

.interval-selects select {
  width: 130px;
}
.interval-selects-type {
  display: flex;
  gap: 5px;
  margin-left: 225px;
  margin-top: -2px;
}

.interval-selects-type select {
  width: 160px;
}


.sct-file-row {
  display: flex;
  align-items: flex-start;
}

.sct-file-options {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  margin-top: -4px;
}

.sct-file-options .custom-checkbox {
  margin-bottom: 4px;
}
.space {
  margin-left: 10px;
}
</style>
<style>
.normal-font label,
.normal-font input,
.normal-font .form-control {
  font-weight: normal !important;
}
</style>
